import { SearchResult, SearchType } from "@/services/search";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faBuilding,
  faCalendarCheck,
  faCalendarDays,
  faChalkboardUser,
  faGraduationCap,
  faIdCard,
  faNoteSticky,
  faSitemap,
  faUserGroup,
  faUsers,
} from "@fortawesome/free-solid-svg-icons";

export const TYPE_LABELS: Record<SearchType, string> = {
  company: "Entreprises",
  person: "Contacts",
  note: "Notes",
  meeting: "Rendez-vous",
  montageMeeting: "Rendez-vous montage",
  companyCourse: "Formations vendues",
  course: "Catalogue",
  instructor: "Formateurs",
  user: "Utilisateurs",
  organisation: "Organismes",
  opco: "OPCO",
};

export const TYPE_ICONS: Record<SearchType, IconDefinition> = {
  company: faBuilding,
  person: faIdCard,
  note: faNoteSticky,
  meeting: faCalendarDays,
  montageMeeting: faCalendarCheck,
  companyCourse: faGraduationCap,
  course: faGraduationCap,
  instructor: faChalkboardUser,
  user: faUsers,
  organisation: faSitemap,
  opco: faUserGroup,
};

/**
 * Destination d'un résultat. Notes, rendez-vous et formations vendues n'ont pas
 * de page à eux : ils renvoient vers la fiche de leur entreprise, sur le bon
 * onglet — d'où le `?tab=`, que la fiche lit depuis l'URL.
 */
export function destinationFor(result: SearchResult): string | null {
  switch (result.type) {
    case "company":
      return `/companies/${result.id}`;
    case "person":
      return result.parentId
        ? `/companies/${result.parentId}?tab=people`
        : "/people";
    case "note":
      return result.parentId ? `/companies/${result.parentId}?tab=notes` : null;
    case "meeting":
      return result.parentId
        ? `/companies/${result.parentId}?tab=meetings`
        : null;
    // Le montage n'a pas de page par rendez-vous ; la fiche lui réserve son
    // propre onglet, visible pour les mêmes utilisateurs que ceux à qui la
    // recherche remonte ces rendez-vous.
    case "montageMeeting":
      return result.parentId
        ? `/companies/${result.parentId}?tab=montage-meetings`
        : null;
    case "companyCourse":
      return result.parentId
        ? `/companies/${result.parentId}?tab=courses`
        : null;
    case "course":
      return "/courses";
    case "instructor":
      return "/instructors";
    case "user":
      return "/users";
    case "organisation":
      return "/organizations";
    case "opco":
      return "/opcos";
    default:
      return null;
  }
}
